import http from "../../helpers/http";

import {
  FETCH_RESCUE_STORIES_CONTENT_SUCCESS,
  FETCH_RESCUE_STORIES_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("rescue-stories")
    .then(({ data }) => {
      dispatch({
        type: FETCH_RESCUE_STORIES_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_RESCUE_STORIES_CONTENT_FAILED,
        payload: error
      });
    });
};
